/* @jsxImportSource react */

import type { FC, ReactNode } from 'react';

export type SlotsContainerProps = {
  children?: ReactNode;
};

export const SlotsContainer: FC<SlotsContainerProps> = ({ children }) => (
  <div
    data-testid="header-slots"
    className="my-0.5 ml-0.5 flex items-center gap-1.5 pr-1 lg:gap-3 xl:mr-0"
  >
    {children}
  </div>
);
